import { useAuth0 } from '@auth0/auth0-react';
import { Button, ButtonProps } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';
import { isNonProdEnv } from '../../utils/env';
export const LoginButton = () => {
  const { loginWithRedirect } = useAuth0();
  const location = useLocation();

  const handleLogin = async () => {
    const returnTo = `${location.pathname}${location.search}${location.hash}`;
    await loginWithRedirect({ appState: { returnTo } });
  };
  return (
    <Button
      bg="background.brandLight"
      color={'white'}
      _hover={{
        bg: 'blue.500',
      }}
      onClick={handleLogin}
    >
      Login with SSO
    </Button>
  );
};

export const LoginWithPasswordButton = (props: ButtonProps) => {
  const { loginWithRedirect } = useAuth0();
  const location = useLocation();

  // Rendered only in dev/qa/localhost; the dev Auth0 tenant is the real
  // boundary (prod/UAT tenants have no DB connection).
  if (!isNonProdEnv()) {
    return null;
  }

  const handleLogin = async () => {
    const returnTo = `${location.pathname}${location.search}${location.hash}`;
    await loginWithRedirect({
      authorizationParams: {
        connection: 'Username-Password-Authentication',
        prompt: 'login',
      },
      appState: { returnTo },
    });
  };
  return (
    <Button variant="outline" colorScheme="blue" onClick={handleLogin} {...props}>
      Log in with Email & Password
    </Button>
  );
};
